export const globalSearchTranslationsDE = {
  search: 'Suche',
  searchPlaceholder: 'Suche startet ab 3 Zeichen',
  searchExplanation: 'Suche nach Namen, Telefonnummer, E-Mail oder Kundennummer',
  hint: 'Hinweis',
  exactSearchExplanationBefore: 'Für exakte Filterung ',
  exactSearchExplanationAfter: 'an den Suchbegriff anhängen.',
  escExplanationBefore: 'Zum Schließen',
  escExplanationAfter: 'drücken',
  noResultsFound: 'Keine Ergebnisse gefunden',
  recentSearches: 'Letzte Suchen',
} as const;
